
<script setup>

  import { ref, computed, watch } from 'vue';

  import { useResizeObserver } from '@vueuse/core';

  const props = defineProps( {

    width: { type: Number, default: 0 },

    height: { type: Number, default: 0 },

    fit: { type: String, default: 'contain', validator: value => [ 'contain', 'cover' ].includes( value ) }
  
  } );

  const outer = ref( null );

  const inner = ref( null );

  const outerWidth = ref( 0 );

  const outerHeight = ref( 0 );

  const outerAspect = ref( 1 );

  const innerWidth = ref( 0 );

  const innerHeight = ref( 0 );

  const innerAspect = computed( () => props.width / props.height );

  const scale = computed( () => innerWidth.value / props.width );

  function resize() {

    const type = props.fit === 'contain' ? outerAspect.value > innerAspect.value : outerAspect.value < innerAspect.value;

    innerWidth.value = type ? outerHeight.value * innerAspect.value : outerWidth.value;

    innerHeight.value = type ? outerHeight.value : outerWidth.value / innerAspect.value;

  }

  useResizeObserver( outer, () => {

    const { width, height } = outer.value.getBoundingClientRect();

    outerWidth.value = width;

    outerHeight.value = height;

    outerAspect.value = width / height;

    resize();

  } );

  watch( innerAspect, () => resize() );

</script>

<template>

  <div ref="outer" class="relative overflow-hidden">

    <div ref="inner"
    
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    
      :style="{ width: `${ innerWidth }px`, height: `${ innerHeight }px` }">

      <slot :scale="scale" />

    </div>

  </div>

</template>
